import { useEffect } from 'react'

import { getReservationCancelAmendPolicy } from '../../actions'
import { reservationWithStatusSelector } from '../../selectors'

import BookingDetails from 'shared/components/BookingDetails'
import Icon from 'shared/components/Icon'

import styles from '../styles.module.scss'

const ReservationDetails = ({ reservation, onClose, getReservationCancelAmendPolicy, translate: t }) => {
    const { isMonthlyPass, rateName } = reservation
    useEffect(() => {
        getReservationCancelAmendPolicy(reservation.reservationId)
    }, [])

    return (
        <div className={styles.transactionDetailsContainer}>
            <div className="text-center clearfix mb-5">
                <div className="float-right">
                    <Icon type="close" onClick={onClose} />
                </div>{' '}
                <h2>{`${t(
                    isMonthlyPass ? 'dashboard.label.subscription' : 'dashboard.label.booking'
                ).toUpperCase()}: ${rateName}`}</h2>
                <BookingDetails reservation={reservation} />
            </div>
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    reservation: reservationWithStatusSelector,
})

const mapDispatchToProps = {
    getReservationCancelAmendPolicy,
}

export default compose(withTranslate, connect(mapStateToProps, mapDispatchToProps))(ReservationDetails)
